// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#player-container-id {\n.vjs-volume-panel {\n    display: none !important;\n}\n}\n", ""]);
// Exports
module.exports = exports;
